export default __webpack_public_path__ + "static/media/Subir Arquivo.e11b9123.svg";